"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../../v2/theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _Item = _interopRequireDefault(require("./component/Item"));

var _lodash = require("lodash");

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var PillSelection = function PillSelection(_ref) {
  var children = _ref.children,
      value = _ref.value,
      onSelect = _ref.onSelect,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "value", "onSelect", "className"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var ref = (0, _react.useRef)(null);
  var classes = useStyles({
    theme: theme
  });

  var _renderItem = function _renderItem(child) {
    if (child && _react["default"].isValidElement(child)) {
      var props = {
        selected: false
      };

      if ((0, _lodash.isEqual)(child.props.value, value)) {
        props.selected = true;
      }

      return _react["default"].cloneElement(child, _objectSpread(_objectSpread({}, props), {}, {
        ref: ref,
        onClick: function onClick(event) {
          var _child$props$onClick, _child$props;

          onSelect(event);
          (_child$props$onClick = (_child$props = child.props).onClick) === null || _child$props$onClick === void 0 ? void 0 : _child$props$onClick.call(_child$props, event);
        }
      }));
    }

    return child;
  };

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.PillSelection, className)
  }, rest), /*#__PURE__*/_react["default"].createElement("ul", null, _react["default"].Children.map(children, _renderItem)));
};

PillSelection.Item = _Item["default"];
var _default = PillSelection;
exports["default"] = _default;
//# sourceMappingURL=index.js.map